import {Component, ViewChild, OnInit} from '@angular/core';
import {MatPaginator, MatSort, MatTableDataSource} from '@angular/material';
import {SelectionModel} from '@angular/cdk/collections';
import * as XLSX from 'xlsx';
import { Router } from '@angular/router';
import * as firebase from 'firebase';

@Component({
  selector: 'app-adminlistados-socios',
  templateUrl: './adminlistados-socios.component.html',
  styleUrls: ['./adminlistados-socios.component.scss']
})
export class AdminlistadosSociosComponent implements OnInit {

  user;
  userId = '';
  ampa;
  // datos de la tabla
  displayedColumns = [
  'select',
  'numero',
  'curso_numero',
  'curso_tutor',
  'nia',
  'apellido1',
  'apellido2',
  'nombre',
  'fecha_nacimiento',
  'comentarios',
  'usuario_dni',
  'usuario_apellido1',
  'usuario_apellido2',
  'usuario_nombre',
  'usuario_email',
  'acciones'
  ];
  selection = new SelectionModel<SociosData>(true, []);
  dataSource: MatTableDataSource<SociosData>;
  socios: SociosData[] = [];
  initialSelection = [];
  allowMultiSelect = true;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor( private router: Router ) {
    console.log('constructor')
  }

   ngOnInit() {
     console.log('ngoninit')
     this.dataSource = new MatTableDataSource(this.socios);
     this.dataSource.paginator = this.paginator;
     this.dataSource.sort = this.sort;
     //obtener datos del usuario admin logueado
     this.userId = localStorage.getItem('userId');
     console.log('UserId', this.userId);
     if(!this.userId){
       this.router.navigate[('')]
     } else {
       firebase.firestore().collection('admins').doc(this.userId)
       .get()
       .then((doc)=>{
         this.user = doc.data();
         console.log('User', this.user)

         this.obtenerSocios();
       })
     }
  }

  // nos traemos los socios del ampa utilizando el id de ampa que tiene el usuario en su documento
  obtenerSocios(){
    console.log('obtenerSocios')
    firebase.firestore().collection('socios')
    .where('ampa','==', this.user.ampa)
    .get()
    .then((snapshot)=>{

      snapshot.forEach((doc)=>{
        console.log('doc',doc)
        //var elemento: SociosData;
        var elemento = doc.data();
        elemento.id = doc.id;
        //hacemos el push
        this.socios = [...this.socios, <SociosData>elemento];
      })
      this.dataSource = new MatTableDataSource(this.socios);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    })
  }



  // mostramos los datos del socio id
  ver(row){
    console.log('Ver ', row.id);
    this.router.navigate(['/admin/socios/ver/' + row.id]);
  }

  // eliminar socios seleccionados
  eliminar(){
      this.selection.selected.forEach((socio) => {
        firebase.firestore().collection('socios').doc(socio.id)
        .delete()
        .catch(error => {console.log(error); })
        .then(()=>{
          console.log('Borrado socio ' + socio.id)
        })
      });
      this.socios = [];
      this.obtenerSocios();
  }

  // actualizamos los datos de algunos campos del socio id
  editar(row){
    console.log('Editado ', row.id)
    this.router.navigate(['/admin/socios/editar/' + row.id])
  }

  //exportamos a xlsx datos de socios seleccionados
  exportToExcel() {
    var ws = XLSX.utils.json_to_sheet(this.selection.selected);
    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Socios");
    XLSX.writeFile(wb, 'socios.xlsx');
  }

  exportToPDF() {

  }


  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected == numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
    this.selection.clear() :
    this.dataSource.data.forEach(row => this.selection.select(row));
  }

}

export interface SociosData {
  id: string;
  numero: string;
  nia: string;
  curso_numero: string;
  curso_tutor: string;
  apellido1: string;
  apellido2: string;
  nombre: string;
  fecha_nacimiento: string;
  comentarios: string;
  usuario_dni: string;
  usuario_apellido1: string;
  usuario_apellido2: string;
  usuario_nombre: string;
  usuario_email: string;

  }



// WEBPACK FOOTER //
// ./src/app/adminlistados-socios/adminlistados-socios.component.ts